module.exports = "/img/../img/login.4c4167e8a5573f5c75b09dea9793f8dd.png";